var map = {
	"./b1/p5About": [
		"UUVA",
		14
	],
	"./b2/p5About": [
		"NLfC",
		11
	],
	"./b3/p5About": [
		"COIP",
		8
	],
	"./b4/p5About": [
		"XfhL",
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "AKAE";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/public lazy ^\.\/.*\/p5About$
// module id = AKAE
// module chunks = 21